<template lang="">
    <div>about us</div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
